import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { toNumber } from 'lodash';
import { editableFundReportForm } from '~/assets/fund/periodicReport';
import { renderMarkdown } from '~/functions/markdown';
import { getLocale } from '~/functions/translate';
import { FundStrategy, useGetFundQuery, useGetFundReportQuery, useGetSectionWithQuestionsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'periodic',
  setup: function setup(__props) {
    var form = editableFundReportForm; // FIXME !!! pure renaming
    var route = useRoute();
    var _useGetFundQuery = useGetFundQuery({
        id: toNumber(route.params.fund)
      }),
      result = _useGetFundQuery.result;
    var fund = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getFund;
    });
    var getFundReportQueryVariables = computed(function () {
      var _fund$value$id, _fund$value;
      return {
        input: {
          id: (_fund$value$id = fund === null || fund === void 0 ? void 0 : (_fund$value = fund.value) === null || _fund$value === void 0 ? void 0 : _fund$value.id) !== null && _fund$value$id !== void 0 ? _fund$value$id : 0,
          referencePeriodId: toNumber(route.query.referencePeriodId)
        }
      };
    });
    var _useGetFundReportQuer = useGetFundReportQuery(getFundReportQueryVariables, computed(function () {
        var _route$query;
        return {
          enabled: !!((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.referencePeriodId)
        };
      })),
      calculatedSfdrReportResult = _useGetFundReportQuer.result;
    var calculatedSfdrReport = computed(function () {
      var _calculatedSfdrReport;
      return (calculatedSfdrReportResult === null || calculatedSfdrReportResult === void 0 ? void 0 : (_calculatedSfdrReport = calculatedSfdrReportResult.value) === null || _calculatedSfdrReport === void 0 ? void 0 : _calculatedSfdrReport.getFundReport) || {
        nameOfFinancialMarketParticipant: '',
        legalEntityIdentifier: ''
      };
    });
    var _useGetSectionWithQue = useGetSectionWithQuestionsQuery(computed(function () {
        var _fund$value2, _fund$value3;
        var input = {
          id: 1220,
          // We default to using article 8 in case no strategy has been selected yet by the fund. That said, this page should ideally not be accessible until a strategy has been selected.
          fundId: toNumber(route.params.fund),
          referencePeriodId: toNumber(route.query.referencePeriodId)
        };
        if (FundStrategy.Article_9 === ((_fund$value2 = fund.value) === null || _fund$value2 === void 0 ? void 0 : _fund$value2.fundStrategy)) {
          input.id = 1202;
        } else if ([FundStrategy.Article_8, FundStrategy.Article_8Plus].includes((_fund$value3 = fund.value) === null || _fund$value3 === void 0 ? void 0 : _fund$value3.fundStrategy)) {
          input.id = 1220;
        }
        return input;
      }), computed(function () {
        var _route$query2;
        return {
          enabled: !!((_route$query2 = route.query) !== null && _route$query2 !== void 0 && _route$query2.referencePeriodId)
        };
      })),
      sectionResult = _useGetSectionWithQue.result,
      loading = _useGetSectionWithQue.loading;
    var section = computed(function () {
      var _sectionResult$value;
      return ((_sectionResult$value = sectionResult.value) === null || _sectionResult$value === void 0 ? void 0 : _sectionResult$value.getSection) || [{
        ixId: '',
        templateTexts: [{
          text: ''
        }]
      }];
    });
    var locale = computed(function () {
      return getLocale();
    });
    return {
      __sfc: true,
      form: form,
      route: route,
      result: result,
      fund: fund,
      getFundReportQueryVariables: getFundReportQueryVariables,
      calculatedSfdrReportResult: calculatedSfdrReportResult,
      calculatedSfdrReport: calculatedSfdrReport,
      sectionResult: sectionResult,
      loading: loading,
      section: section,
      locale: locale,
      renderMarkdown: renderMarkdown
    };
  }
});